/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ConnectorSnapshot
 */
export interface ConnectorSnapshot {
    /**
     *
     * @type {number}
     * @memberof ConnectorSnapshot
     */
    connectorNumber?: number;
    /**
     *
     * @type {string}
     * @memberof ConnectorSnapshot
     */
    ocppStatus?: string;
    /**
     *
     * @type {number}
     * @memberof ConnectorSnapshot
     */
    assignedAmps?: number;
    /**
     *
     * @type {number}
     * @memberof ConnectorSnapshot
     */
    feedbackL1Amps?: number;
    /**
     *
     * @type {number}
     * @memberof ConnectorSnapshot
     */
    feedbackL2Amps?: number;
    /**
     *
     * @type {number}
     * @memberof ConnectorSnapshot
     */
    feedbackL3Amps?: number;
    /**
     *
     * @type {Date}
     * @memberof ConnectorSnapshot
     */
    feedbackTimestamp?: Date;
}

/**
 * Check if a given object implements the ConnectorSnapshot interface.
 */
export function instanceOfConnectorSnapshot(
    value: object,
): value is ConnectorSnapshot {
    return true;
}

export function ConnectorSnapshotFromJSON(json: any): ConnectorSnapshot {
    return ConnectorSnapshotFromJSONTyped(json, false);
}

export function ConnectorSnapshotFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorSnapshot {
    if (json == null) {
        return json;
    }
    return {
        connectorNumber:
            json["connectorNumber"] == null
                ? undefined
                : json["connectorNumber"],
        ocppStatus: json["ocppStatus"] == null ? undefined : json["ocppStatus"],
        assignedAmps:
            json["assignedAmps"] == null ? undefined : json["assignedAmps"],
        feedbackL1Amps:
            json["feedbackL1Amps"] == null ? undefined : json["feedbackL1Amps"],
        feedbackL2Amps:
            json["feedbackL2Amps"] == null ? undefined : json["feedbackL2Amps"],
        feedbackL3Amps:
            json["feedbackL3Amps"] == null ? undefined : json["feedbackL3Amps"],
        feedbackTimestamp:
            json["feedbackTimestamp"] == null
                ? undefined
                : new Date(json["feedbackTimestamp"]),
    };
}

export function ConnectorSnapshotToJSON(value?: ConnectorSnapshot | null): any {
    if (value == null) {
        return value;
    }
    return {
        connectorNumber: value["connectorNumber"],
        ocppStatus: value["ocppStatus"],
        assignedAmps: value["assignedAmps"],
        feedbackL1Amps: value["feedbackL1Amps"],
        feedbackL2Amps: value["feedbackL2Amps"],
        feedbackL3Amps: value["feedbackL3Amps"],
        feedbackTimestamp:
            value["feedbackTimestamp"] == null
                ? undefined
                : value["feedbackTimestamp"].toISOString(),
    };
}
